import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { DataGrid,    esES } from '@mui/x-data-grid';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  Button,
  Tooltip,
  IconButton,
  TextField,
  Grid
} from '@mui/material';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaFilePdf, FaPlus, FaUpload, FaEye } from 'react-icons/fa';

import { getMobiliarios, subirImagenMobiliario } from '../../../redux/actions/mobiliarioactions';
import NuevoMobiliario from './NuevoMobiliario';
import SubirMobiliarioExcel from './SubirMobiliarioExcel';
import MyButton from '../../../utils/MyButton';
import './TablaMobiliario.css';

const TablaMobiliario = ({ getMobiliarios, subirImagenMobiliario, dataMob, clienteId }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [open, setOpen] = useState(false);
  const [mobiliarioid, setMobiliarioid] = useState('');
 const [globalFilter, setGlobalFilter] = useState('');
const fileInputRef = React.useRef(null);
const [previewUrl, setPreviewUrl] = useState(null);
  useEffect(() => {
    getMobiliarios(clienteId);
  }, [clienteId, getMobiliarios]);

  const handleOpen = (id) => {
    setMobiliarioid(id);
    setOpen(true);
  };

 const handleClose = () => {
  setOpen(false);
  setMobiliarioid('');
  setSelectedFile(null);
  setPreviewUrl(null);
};

  const onFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const onFileUpload = () => {
    if (selectedFile) {
      const formData = new FormData();
      formData.append("myFile", selectedFile, selectedFile.name);
      subirImagenMobiliario(formData, mobiliarioid, clienteId);
      setOpen(false);
    }
  };

    const applyFilters = (rows) => {
    if (!globalFilter) return rows;
    const filter = globalFilter.toLowerCase();
    return rows.filter((row) =>
      ['idinventario','nombre','marca','modelo','serie','ubicacion','servicio','estado','tipo']
        .some((key) => row[key]?.toString().toLowerCase().includes(filter))
    );
  };

  const columns = [
     {
      field: 'actions',
      headerName: 'Acciones',
      width: 100,
      sortable: false,
      renderCell: (params) => (
        <div>
          <Tooltip title="Ver Perfil">
            <IconButton size="small"
                        color="primary" component={Link} to={`/dashboard/perfilcliente/mobiliario/${clienteId}/${params.row.mobiliarioid}`}>
              <FaEye />
            </IconButton>
          </Tooltip>
          <Tooltip title="Subir Imagen">
            <IconButton size="small"
                        color="primary" onClick={() => handleOpen(params.row.mobiliarioid)}>
              <FaUpload />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
    {
      field: 'imagenurl',
      headerName: 'Avatar',
      width: 90,
      renderCell: (params) => (
        <img src={params.value} style={{ width: 40, borderRadius: '50%' }} alt="avatar" />
      ),
    },
    { field: 'idinventario', headerName: 'Id', width: 130},
    { field: 'nombre', headerName: 'Nombre', width: 150 },
    { field: 'marca', headerName: 'Marca', width: 130 },
    { field: 'modelo', headerName: 'Modelo', width: 130 },
    { field: 'serie', headerName: 'Serie', width: 130 },
    { field: 'ubicacion', headerName: 'Ubicación', width: 150 },
    { field: 'servicio', headerName: 'Servicio', width: 150 },
    { field: 'estado', headerName: 'Estado', width: 150 },
    { field: 'tipo', headerName: 'Tipo', width: 150 },
   
  ];

  const { mobiliarios, loadingdata } = dataMob;

  if (loadingdata) {
    return (
      <div className="div_cargando">
        <CircularProgress size={50} color="primary" className="login-progress" />
      </div>
    );
  }
  const filteredRows = applyFilters(mobiliarios);

  return (
    <div>
      <div className='div-container-links-infra'>
        <NuevoMobiliario clienteId={clienteId} />
        <SubirMobiliarioExcel clienteId={clienteId} />
        <Fragment>
          <Link className='div-card-link' to={`/dashboard/perfilcliente/inventariopdfmobiliario/${clienteId}`} state={mobiliarios}>
            <div className="dashing-cardcontent">
              <div className="dashing-cardtext">
                <p className="dashing-text-card">Exportar Inventario</p>
              </div>
              <div className="dashing-cardicon-green">
                <FaFilePdf color="#FFFFFF" className="dashing-icon" />
              </div>
            </div>
          </Link>
        </Fragment>
      </div>

     

      <div style={{ height: 600, width: '95%',padding:5, marginLeft:5 }}>
        <Grid container spacing={2} style={{ marginBottom: '1rem' }}>
        <Grid item xs={12}>
          <TextField
            label="Buscar en todos los campos"
            variant="outlined"
            size="small"
            fullWidth
            onChange={(e) => setGlobalFilter(e.target.value)}
          />
        </Grid>
      </Grid>
        <DataGrid
         pageSize={10}
                        rowsPerPageOptions={[5, 10, 20]}
                        autoHeight
                        
                        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                        sx={{
                            borderRadius: 2,
                            backgroundColor: '#fff',
                            boxShadow: 3,
                            '& .MuiDataGrid-cell': {
                              fontSize: 14,
                            },
                            '& .MuiDataGrid-columnHeaders': {
                              backgroundColor: '#0588FB',
                              color: '#fff',
                              fontWeight: 'bold',
                              fontSize: 15,
                            },
                            '& .MuiDataGrid-row:hover': {
                              backgroundColor: '#f5f5f5',
                            },
                          }}
        rows={filteredRows} columns={columns} getRowId={(row) => row.mobiliarioid}  />
      </div>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Subir Imagen del Equipo Mobiliario o Industrial</DialogTitle>
        
          <DialogContent>
  <div
    onClick={() => fileInputRef.current.click()}
    onDragOver={(e) => e.preventDefault()}
    onDrop={(e) => {
      e.preventDefault();
      const file = e.dataTransfer.files[0];
      if (file) {
        setSelectedFile(file);
        setPreviewUrl(URL.createObjectURL(file));
      }
    }}
    style={{
      border: '2px dashed #aaa',
      borderRadius: '10px',
      padding: '30px',
      textAlign: 'center',
      cursor: 'pointer',
      backgroundColor: '#f9f9f9',
    }}
  >
    {selectedFile ? (
      <p>Archivo seleccionado: {selectedFile.name}</p>
    ) : (
      <p>Haz clic o arrastra una imagen aquí</p>
    )}
  </div>

  <input
    type="file"
    accept="image/*"
    ref={fileInputRef}
    style={{ display: 'none' }}
    onChange={(e) => {
      const file = e.target.files[0];
      if (file) {
        setSelectedFile(file);
        setPreviewUrl(URL.createObjectURL(file));
      }
    }}
  />

  {previewUrl && (
    <img src={previewUrl} alt="Vista previa" style={{ width: '100%', marginTop: '1rem', borderRadius: '8px' }} />
  )} </DialogContent>
        <DialogActions>
          <MyButton tip="Cerrar" onClick={handleClose}>
            <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
          </MyButton>
          <MyButton tip="Subir Imagen del Equipo" onClick={onFileUpload}>
            <FaPlus color="#03178C" className="icon-formulario" />
          </MyButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

TablaMobiliario.propTypes = {
  getMobiliarios: PropTypes.func.isRequired,
  dataMob: PropTypes.object.isRequired,
  clienteId: PropTypes.string.isRequired,
  subirImagenMobiliario: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  dataMob: state.dataMob,
});

export default connect(mapStateToProps, { getMobiliarios, subirImagenMobiliario })(TablaMobiliario);
